<template>
  <div>
    <el-form label-width="80px">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="用户名称">
            <el-input
              v-model="searchForm.name"
              placeholder="用户名称"
              clearable
              class="cus_width"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="审核状态">
            <el-select
              v-model="searchForm.type"
              clearable
              class="cus_width"
              placeholder="审核状态"
            >
              <el-option label="待审核" value="2"></el-option>
              <el-option label="审核通过" value="1"></el-option>
              <el-option label="审核驳回" value="3"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <el-button @click="getConfig" type="success">搜索</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      border
      stripe
    >
      <el-table-column
        label="审核状态"
        align="center"
        prop="updateTime"
        width="160"
      >
        <template slot-scope="{ row }">
          <span v-if="row.isWithdraw == 0" style="color: #909399">待审核</span>
          <span v-if="row.isWithdraw == 1" style="color: #67c23a"
            >审核通过</span
          >
          <span v-if="row.isWithdraw == 2" style="color: #f56c6c"
            >审核驳回</span
          >
        </template></el-table-column
      >
      <el-table-column
        label="提现用户"
        align="center"
        prop="nickName"
        width="160"
      ></el-table-column>
      <el-table-column
        label="手机号"
        align="center"
        prop="phone"
        width="160"
      ></el-table-column>

      <el-table-column
        label="提现金额"
        align="center"
        prop="amount"
        width="160"
      ></el-table-column>

      <el-table-column
        label="提现持卡人姓名"
        align="center"
        prop="cardHolderName"
        width="160"
      ></el-table-column>
      <el-table-column
        label="卡号"
        align="center"
        prop="cardNumber"
        width="200"
      ></el-table-column>
      <el-table-column
        label="银行"
        align="center"
        prop="bankName"
        width="160"
      ></el-table-column>

      <el-table-column
        label="卡开户行"
        align="center"
        prop="cardType"
        width="240"
      ></el-table-column>
      <el-table-column
        label="创建时间"
        align="center"
        width="160"
        prop="createTime"
      ></el-table-column>
      <el-table-column
        label="审核说明"
        align="center"
        width="160"
        prop="remark"
      ></el-table-column>
      <el-table-column
        label="审核时间"
        align="center"
        width="160"
        prop="updateTime"
      ></el-table-column>

      <el-table-column
        label="操作"
        align="center"
        prop="icon"
        fixed="right"
        width="100"
      >
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.isWithdraw == 0 && hasAuth('sys:withdra:shenhe')"
            type="primary"
            plain
            @click="UpdateConfigTypeButton(scope.row)"
            >审核</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="searchForm.pageNo"
      :page-size="searchForm.pageSize"
      :total="total"
    ></el-pagination>

    <el-dialog
      title="审核"
      :visible.sync="dialogVisible"
      width="800px"
      append-to-body
      :before-close="handleClose"
    >
      <el-form
        :model="editForm"
        ref="editForm"
        label-width="100px"
        class="demo-editForm"
      >
        <el-divider content-position="left">提现信息</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">提现用户：{{ editForm.nickName }}</el-col>
          <el-col :span="12">提现用户手机号：{{ editForm.phone }}</el-col>
          <el-col :span="12"
            >提现金额：{{ Math.abs(editForm.amount) }}元</el-col
          >
          <el-col :span="12">提现时间：{{ editForm.createTime }}</el-col>
          <el-col :span="12">银行名称：{{ editForm.bankName }}</el-col>
          <el-col :span="12">开户行：{{ editForm.cardType }}</el-col>
          <el-col :span="12">持卡人姓名：{{ editForm.cardHolderName }}</el-col>
          <el-col :span="12">卡号：{{ editForm.cardNumber }}</el-col>
        </el-row>

        <el-divider content-position="left">审核</el-divider>
        <el-form-item label-width="100px" label="审核状态">
          <el-radio v-model="type" label="1">审核通过</el-radio>
          <el-radio v-model="type" label="2">审核驳回</el-radio>
        </el-form-item>
        <el-form-item
          label-width="100px"
          :label="type == 1 ? '通过说明' : '驳回说明'"
        >
          <el-input v-model="remark" type="textarea" :rows="2"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm()">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import VploadImg from "../inc/VploadImgTwo";
export default {
  name: "amount",
  components: {
    VploadImg,
  },
  data() {
    return {
      searchForm: {
        name: "",
        type: "",
        pageNo: 1,
        pageSize: 10,
      },
      shopForm: {},
      tableData: [],
      multipleSelection: [],
      editForm: {},
      dialogVisible: false,
      remark: null,
      type: 1,
      total: 0,
    };
  },
  created() {
    this.getConfig();
  },
  methods: {
    UpdateConfigTypeButton(i) {
      this.editForm = JSON.parse(JSON.stringify(i));
      this.dialogVisible = true;
    },
    getConfig() {
      this.$axios
        .post("/admin/balanceRecord/getWithdrawalList", this.searchForm)
        .then((res) => {
          this.tableData = res.data.records;
          this.total = res.data.total;
        });
    },
    handleSizeChange(i) {
      this.searchForm.pageSize = i;
      this.getConfig();
    },

    handleCurrentChange(i) {
      this.searchForm.pageNo = i;
      this.getConfig();
    },

    delHandle(id) {
      this.$axios
        .post("/admin/rechargeAmount/del", {
          id: id,
        })
        .then((res) => {
          this.getConfig();
          this.$message({
            showClose: true,
            message: "恭喜你，操作成功",
            type: "success",
            onClose: () => {},
          });
        });
    },
    handleClose() {
      this.dialogVisible = false;
      this.remark = null;
      this.type = 1;
    },
    submitForm() {
      this.$axios
        .post("/admin/balanceRecord/auditWithdraw", {
          money: this.money,
          id: this.editForm.id,
          remark: this.remark,
          type: this.type,
        })
        .then((res) => {
          this.dialogVisible = false;
          this.getConfig();
          this.$message({
            showClose: true,
            message: "恭喜你，操作成功",
            type: "success",
            onClose: () => {},
          });
        });
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}
</style>
